/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_RetryInputs */

const vi_print_admin_retry = /** @type {(inputs: Print_Admin_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In lại`)
};

/**

* @param {Print_Admin_RetryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_retry = /** @type {((inputs?: Print_Admin_RetryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_RetryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_retry(inputs)
});